export default class KBMediaType {
  static readonly Image = 1;
  static readonly Video = 2;
  static readonly File = 3;
}
